var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditAffiliate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5563 10.1234L13.8361 6.44169L15.0616 5.21447L16.2868 3.99805L17.5344 5.21447L18.7598 6.44169L20.0015 7.65376L18.8036 8.87422L17.5563 10.1234Z",
    fill: "#5D75F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.28 6.9821L17.0001 10.7076L7.72583 19.9994H4.00146V16.2899L13.28 6.9821ZM6.97759 18.3996H5.60122V17.019L13.1509 9.45846L13.8824 10.1106L14.5273 10.6857L6.97759 18.3996Z",
    fill: "#5D75F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAffiliate);
export default __webpack_public_path__ + "static/media/EditAffiliate.04d3eb56f717352f5ef15d2add24502b.svg";
export { ForwardRef as ReactComponent };